import { jsx as _jsx } from "react/jsx-runtime";
import { CortexClient } from '@cortex/sdk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext, useContext, useMemo } from 'react';
const ClientContext = createContext(null);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    },
});
export function CortexProvider({ baseUrl, jwt, onUnauthorized, children }) {
    const client = useMemo(() => new CortexClient({ baseUrl, jwt, onUnauthorized }), [baseUrl, jwt, onUnauthorized]);
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(ClientContext.Provider, { value: client, children: children }) }));
}
export function useClient() {
    const client = useContext(ClientContext);
    if (!client)
        throw new Error('useClient must be used inside CortexProvider');
    return client;
}
//# sourceMappingURL=provider.js.map